// extracted by mini-css-extract-plugin
module.exports = {"home-middle-banner":"style_home-middle-banner__deeiA"};